var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VerMovimiento'),_c('ag-grid-vue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"100%","height":"60vh"},attrs:{"gridOptions":_vm.gridOptions,"columnDefs":_vm.columnDefs,"defaultColDef":_vm.defaultColDef,"rowData":_vm.rowData,"getContextMenuItems":_vm.getContextMenuItems},on:{"grid-ready":_vm.onGridReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }